import React from 'react';
import './NomeFrigorifico.css';

const RI_INICIO = 0x1F1E6;
const RI_FIM = 0x1F1FF;

function codigoBandeira(cp1, cp2) {
  return String.fromCharCode(0x41 + (cp1 - RI_INICIO)) + String.fromCharCode(0x41 + (cp2 - RI_INICIO));
}

function parseBandeirasNome(nome) {
  const texto = String(nome || '');
  const chars = Array.from(texto);
  const flags = [];
  let i = 0;
  while (i + 1 < chars.length) {
    const a = chars[i].codePointAt(0);
    const b = chars[i + 1].codePointAt(0);
    if (a >= RI_INICIO && a <= RI_FIM && b >= RI_INICIO && b <= RI_FIM) {
      flags.push(codigoBandeira(a, b).toLowerCase());
      i += 2;
    } else {
      break;
    }
  }
  const resto = chars.slice(i).join('').trim();
  return { flags, resto: resto || texto };
}

export default function NomeFrigorifico({ name }) {
  const { flags, resto } = parseBandeirasNome(name);
  return (
    <span className="frig-nome">
      {flags.map((code, index) => (
        <img
          key={`${code}-${index}`}
          className="frig-flag"
          src={`https://flagcdn.com/20x15/${code}.png`}
          alt={code.toUpperCase()}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      ))}
      <span>{resto}</span>
    </span>
  );
}
